import { Navigate } from 'react-router-dom'
import { useAuth, SignUpPanel } from '@/lib/auth'

export function SignUpPage() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return null
  }

  if (isAuthenticated) {
    return <Navigate to="/overview" replace />
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <SignUpPanel />
    </div>
  )
}
